import React from 'react';
import tw from 'tailwind-styled-components';
import { FaUser, FaCamera, FaHeadset, FaLanguage } from 'react-icons/fa';

const ProfileHeader = ({ displayData, onUserClick, onHelpCenter, onChangeLanguage }) => {
  return (
    <HeaderContainer>
      <DesktopLayout>        {/* Desktop Layout */}
        <LeftSection>
          <ProfileCard onClick={onUserClick}>
            <ProfileImageContainer>
              <ProfileImage>
                <FaUser className="w-12 h-12 text-gray-400" />
              </ProfileImage>
              <CameraIcon>
                <FaCamera className="w-4 h-4 text-gray-600" />
              </CameraIcon>
            </ProfileImageContainer>
            <UserInfo>
              <UserName>
                {displayData?.first_name && displayData?.last_name
                  ? `${displayData.first_name} ${displayData.last_name}`
                  : displayData?.first_name || displayData?.email || "User"}
              </UserName>
              <ViewProfileText>View Profile</ViewProfileText>
            </UserInfo>
          </ProfileCard>
        </LeftSection>
        <RightSection>
          <ActionCard onClick={onHelpCenter}>
            <ActionCardIcon>
              <FaHeadset className="w-8 h-8 text-kuality-blue" />
            </ActionCardIcon>
            <ActionCardText>Help Centre</ActionCardText>
          </ActionCard>

          <ActionCard onClick={onChangeLanguage}>
            <ActionCardIcon>
              <FaLanguage className="w-8 h-8 text-kuality-blue" />
            </ActionCardIcon>
            <ActionCardText>Change Language</ActionCardText>
          </ActionCard>
        </RightSection>
      </DesktopLayout>

      {/* Mobile Layout */}
      <MobileLayout>
        <ProfileSection onClick={onUserClick}>
          <ProfileImageContainer>
            <ProfileImage>
              <FaUser className="w-12 h-12 text-gray-400" />
            </ProfileImage>
            <CameraIcon>
              <FaCamera className="w-4 h-4 text-gray-600" />
            </CameraIcon>
          </ProfileImageContainer>
          <UserInfo>
            <UserName>
              {displayData?.first_name && displayData?.last_name
                ? `${displayData.first_name} ${displayData.last_name}`
                : displayData?.first_name || displayData?.email || "User"}
            </UserName>
            <ViewProfileText>View Profile</ViewProfileText>
          </UserInfo>
          <ArrowIcon>
            <svg className="w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </ArrowIcon>
        </ProfileSection>

        <ActionCardsContainer>
          <ActionCard onClick={onHelpCenter}>
            <ActionCardIcon>
              <FaHeadset className="w-8 h-8 text-kuality-blue" />
            </ActionCardIcon>
            <ActionCardText>Help Centre</ActionCardText>
          </ActionCard>
          <ActionCard onClick={onChangeLanguage}>
            <ActionCardIcon>
              <FaLanguage className="w-8 h-8 text-kuality-blue" />
            </ActionCardIcon>
            <ActionCardText>Change Language</ActionCardText>
          </ActionCard>
        </ActionCardsContainer>
      </MobileLayout>
    </HeaderContainer>
  );
};

// Styled Components
const HeaderContainer = tw.div`
  bg-white
`;

const DesktopLayout = tw.div`
  hidden md:flex md:justify-between md:items-center md:p-6 md:max-w-6xl md:mx-auto md:gap-6
`;

const LeftSection = tw.div`
  flex-shrink-0
`;

const RightSection = tw.div`
  flex gap-4 flex-1 justify-end max-w-md
`;

const MobileLayout = tw.div`
  md:hidden
`;

const ProfileCard = tw.div`
  bg-white border border-gray-200 rounded-xl p-6 flex flex-col items-center cursor-pointer hover:shadow-md transition-shadow min-w-[200px]
`;

const ProfileSection = tw.div`
  flex items-center justify-between p-4 bg-white cursor-pointer hover:bg-gray-50 transition-colors
`;

const ProfileImageContainer = tw.div`
  relative flex-shrink-0 mb-4 md:mb-4
`;

const ProfileImage = tw.div`
  w-16 h-16 md:w-20 md:h-20 bg-gray-100 rounded-full flex items-center justify-center
`;

const CameraIcon = tw.div`
  absolute bottom-0 right-0 w-6 h-6 md:w-8 md:h-8 bg-white rounded-full flex items-center justify-center border border-gray-300 shadow-sm
`;

const UserInfo = tw.div`
  flex-1 ml-4 md:ml-0 md:flex-none md:text-center
`;

const UserName = tw.h2`
  text-lg md:text-xl font-semibold text-gray-900
`;

const ViewProfileText = tw.p`
  text-sm text-gray-500 mt-1
`;

const ArrowIcon = tw.div`
  flex-shrink-0 md:hidden
`;

const ActionCardsContainer = tw.div`
  flex space-x-4 px-4 bg-white justify-center
`;

const ActionCard = tw.div`
  flex-1 md:flex-none border border-gray-200 rounded-md p-4 md:p-6 flex flex-col items-center cursor-pointer hover:shadow-md transition-shadow bg-gray-100 md:w-40 md:min-w-[200px]
`;

const ActionCardIcon = tw.div`
  mb-3
`;

const ActionCardText = tw.span`
  text-gray-800 font-medium text-sm text-center
`;

export default ProfileHeader;